import progressNotesForm from './progressNotesForm';

// const progressNotesJSON = {
//   section: 'PN',
//   topic: 'Progress Notes',
//   checked: true,
//   color: 'secondary',
//   description: '(optional)',
//   body: [
//     {
//       id: 'PN.1',
//       shortname: 'pn1',
//       // access: 'private',
//       name: '',
//       prevalue: '',
//       buttonname: 'New Progress Note',
//       value: '100',
//       disabled: 'false',
//       type: 'new_progress_note',
//       act: 'PN1',
//       depending: '',
//       exception: '',
//     },
//     {
//       id: 'PN.meta',
//       shortname: 'pn_meta',
//       name: 'Meta Info',
//       type: 'META_INFO',
//       items: [
//         {
//           id: 'meta_table',
//           label: 'Progress Notes Table',
//           type: 'table',
//           rows: [
//             {
//               created: '2025-03-01',
//               updated: '2025-03-02',
//               provider: 'Dr. Brown',
//               description: 'Initial evaluation',
//               progress_notes_json: {
//                 section: 'PN',
//                 body: [
//                   {
//                     id: 'created',
//                     label: 'Created',
//                     type: 'label',
//                     value: '2025-03-01',
//                   },
//                   {
//                     id: 'description',
//                     label: 'Note',
//                     type: 'textarea',
//                     value: 'Patient is stable',
//                     act: 'PN_DESCRIPTION',
//                   },
//                 ],
//               },
//             },
//             {
//               created: '2025-03-10',
//               updated: '2025-03-11',
//               provider: 'Dr. Grey',
//               description: 'Follow-up',
//               progress_notes_json: {
//                 section: 'PN',
//                 body: [
//                   {
//                     id: 'created',
//                     label: 'Created',
//                     type: 'label',
//                     value: '2025-03-10',
//                   },
//                   {
//                     id: 'description',
//                     label: 'Note',
//                     type: 'textarea',
//                     value: 'Improved condition',
//                     act: 'PN_DESCRIPTION',
//                   },
//                 ],
//               },
//             },
//           ],
//         },
//       ],
//     },
//   ],
// };

const progressNotesJSON = {
  section: 'PN',
  topic: 'Progress Notes',
  checked: true,
  color: 'secondary',
  description: '(optional)',
  body: [
    {
      id: 'PN.1',
      shortname: 'pn1',
      // access: 'private',
      name: '',
      prevalue: '',
      buttonname: 'New Progress Note',
      value: '100',
      disabled: 'false',
      type: 'new_progress_note',
      act: 'PN1',
      depending: '',
      exception: '',
    },
    {
      id: 'PN.2',
      shortname: 'pn2',
      name: 'Progress Notes Table',
      prevalue: '',
      disabled: 'false',
      type: 'table',
      value :'0',
      value2 : `0`,
      rows: [
        // {
        //   created: '2025-03-01',
        //   updated: '2025-03-02',
        //   provider: 'Dr. Brown',
        //   description: 'Initial evaluation',
        // },
        // {
        //   created: '2025-03-10',
        //   updated: '2025-03-11',
        //   provider: 'Dr. Grey',
        //   description: 'Follow-up',
        // },
      ],
      depending: '',
      exception: '',
    },
  ],
};

export default progressNotesJSON;
